import {onFind} from "@elements/init-modules-in-scope";
import { getApi } from '@elements/form-validation';

export function init () {
    onFind('.js-form-validation-scroll', baseElement => {
        let formInstance;
        getApi(baseElement).then((formApi) => {
            formInstance = formApi.getFormInstance();

            formInstance.on('core.form.invalid', () => {
                const invalidInputs = baseElement.querySelectorAll('.is-invalid');
                if (invalidInputs.length > 0) {
                    window.scrollTo({
                        behavior: 'smooth',
                        top:
                            invalidInputs[0].getBoundingClientRect().top -
                            document.body.getBoundingClientRect().top -
                            300
                    });
                }
            })
        });
    });
}